import { StyleSheet } from 'react-native';

import { Fonts, Metrics, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

const badgeContainerHeight = 25;
export default StyleSheet.create({
  containerStyle: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.transparentColor,
    flex: 1,
    height: 210,
    marginHorizontal: 8,
    width: Metrics.galleryCardWidth,
  }),
  imageStyle: {
    height: 120,
    marginTop: -71,
    width: 120,
  },
  badgeStyle: width => ({
    alignSelf: 'flex-end',
    marginTop: 5,
    position: 'relative',
    right: 10,
    top: 13,
    zIndex: 999,
    width: width,
  }),
  subTitleStyle: theme => ({
    color: theme.colors.textColorTwo,
    fontSize: Fonts.size.medium,
    letterSpacing: 0,
    lineHeight: 18,
    textAlign: 'center',
    paddingHorizontal: 10,
  }),
  descriptionStyle: {
    marginTop: 20,
    bottom: 2,
  },
  textContainerStyle: (theme, withLock) => ({
    backgroundColor: theme.colors.backgroundColorSeven,
    borderRadius: 6,
    height: 136,
    width: Metrics.galleryCardWidth,
    paddingTop: 18,
    borderColor: theme.colors.VFDivider.tertiary,
    borderWidth: withLock ? 1 : 0,
  }),
  titleStyle: theme => ({
    color: theme.colors.textColorTwo,
    fontSize: Fonts.size.medium,
    fontWeight: 'bold',
    letterSpacing: 0,
    lineHeight: 18,
    marginBottom: 8,
    textAlign: 'center',
  }),
  lockContainer: theme => ({
    position: 'absolute',
    alignSelf: 'center',
    top: 7,
    width: 27,
    height: 27,
    borderRadius: 27 / 2,
    backgroundColor: theme.colors.VFDivider.tertiary,
    zIndex: 1000,
    alignItems: 'center',
    justifyContent: 'center',
  }),
  badgeContainer: {
    height: badgeContainerHeight,
    position: 'relative',
    width: Metrics.galleryCardWidth,
  },
  recommendedBadageContainer: height => ({
    borderRadius: 6.2,
    backgroundColor: Colors.ocean,
    position: 'absolute',
    width: '101%',
    height: height + badgeContainerHeight - 5,
    alignSelf: 'center',
  }),
  textStyle: {
    ...Fonts.type.bold,
    fontSize: 12,
    color: Colors.white,
    textAlign: 'center',
    paddingTop: 5,
  },
});
